import axios from "axios";
import { FILE_SAVED, HANDLE_ERRORS } from "./types";
import BASE_URL from '../helpers/base-url';
import authorizeRequest from "../helpers/authorize-request";

export const saveNewPasswords = (
    currentPassword,
    operatorPassword,
    customerPassword
) => async (dispatch) => {
  await axios
      .post(`${BASE_URL}/api/update-password`, {
        currentPassword,
        operatorPassword,
        customerPassword
      }, authorizeRequest())
      .then(res => {
        dispatch({
          type: FILE_SAVED,
          payload: {
            message:
                "New password saved!"
          }
        });
      })
      .catch(error => {
        console.error("error writing to json file", error);
        dispatch({
          type: HANDLE_ERRORS,
          payload: {
            message: "Passwords not Saved! Please try again.",
            open: true
          }
        });
      });

};



// WEBPACK FOOTER //
// ./src/actions/permissions_actions.js